import React, { useEffect } from 'react';

interface AutoSubmitProps {
    dirty: boolean;
    submitForm: () => void;
}

const AutoSubmit: React.FC<AutoSubmitProps> = ({ dirty, submitForm }) => {
    useEffect(() => {
        if (dirty) {
            setTimeout(() => {
                submitForm();
            }, 0);
        }
    }, [dirty, submitForm]);

    return null;
};

export default AutoSubmit;
